module.exports = __webpack_public_path__ + "media/images/apple-store-badge-8bb87fed.png";